import moment from 'moment';

export default {
  // 字典结构过滤器
  formatDictionary: function (value, list) {
    if (!value || !list) {
      return '';
    }
    const item = list.find(t => `${t.value}` === `${value}`) || {};
    return item.name;
  },
  // 格式化价格
  formatPrice: function (price) {
    return `${price}元`;
  },
  // 格式化时间
  formatDate: function (str, rule) {
    return str && moment(str).format(rule || 'YYYY-MM-DD');
  },
  // 格式化为数字
  formatInt: function (str) {
    return Number.parseInt(str, 10);
  },
  // 格式化false为空字符串
  formatEmpty: function (value) {
    return value || '';
  },
  // 格式化浮点数（保留小数点后几位）
  formatNumberCalc: function (value, digit = 2) {
    return Math.round(Number.parseFloat(`${value}`) * (10 ** digit)) / (10 ** digit);
  },
  // 分钟转时分
  formatHourMinute: function (value) {
    return `${Math.floor(value / 60) >= 10 ? '' : 0}${Math.floor(value / 60)}:${value % 60 >= 10 ? '' : 0}${Number.parseInt(value % 60, 10)}`;
  }
};
